<template>
  <ResourceDialog
    @save="$emit('save')"
    ref="attachmentDialog"
    :processing="processing"
    :save-button-disabled="uploadedAttachments.length < 1"
    save-button-text="Send"
    title="Send attachments"
  >
    <template #form>
      <UppyDashboard
        :props="uppyProps"
        :uppy="uppy"
      />
    </template>
  </ResourceDialog>
</template>

<script setup>
import ResizeObserver from 'resize-observer-polyfill';
import Uppy from '@uppy/core';
import { Dashboard as UppyDashboard } from '@uppy/vue';
import XHRUpload from '@uppy/xhr-upload';

import ResourceDialog from '@/shared/components/form/ResourceDialog.vue';
import useUppyUtils from '@/shared/composables/useUppyUtils';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';

window.ResizeObserver = ResizeObserver;

const { getUploadAPIEndpoint, createUppyPropsWithLocale } = useUppyUtils();

defineProps({
  processing: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['save', 'upload']);

defineExpose({ cancelAll, close, open });

const attachmentDialog = ref(null);
const uppy = ref(null);
const uploadedAttachments = ref([]);
const { uppyProps, setupUppyWithTranslations } = createUppyPropsWithLocale();

onBeforeUnmount(() => {
  uppy.value.close();
});

onMounted(() => {
  setupUppyWithTranslations(() => {
    uppy.value = new Uppy().use(XHRUpload, {
      endpoint: getUploadAPIEndpoint(),
    });

    uppy.value.on('upload-success', (file, evt) => {
      const asset = {
        file: {
          id: evt.body.id,
          storage: 'cache',
          metadata: {
            size: file.size,
            filename: file.name,
            mime_type: file.type,
          },
        },
      };

      uploadedAttachments.value.push(asset);
      emit('upload', asset);
    });
  });
});

function close() {
  attachmentDialog.value.close();
}

function open() {
  uploadedAttachments.value = [];
  attachmentDialog.value.open();
}

function cancelAll() {
  uppy.value.cancelAll();
}
</script>
